import React, { useEffect } from 'react';

/**
 * VideoPlayer component that conditionally renders a video player based on the provided URL.
 * 
 * @param {string} url - The URL of the video to play.
 * @returns {JSX.Element} The rendered video player component.
 */
export function VideoPlayer({ url }) {
    /** 
     * Logs an error if no video URL is provided
    */
    useEffect(() => {
        if (!url) {
            console.error("No video URL provided.")
        }
    }, [url])

    return (
        <>
            {url ?
                <video src={url} controls autoPlay="on" className="video" />
                :
                <div className="error-message">
                    <p>Oops! Videon kunde inte laddas in.</p>
                </div>
            }
        </>

    )
}